// functions.js file copypasted below

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

// functions.js file from the original client's code
jQuery(document).ready(function($){
    // Add .img-responsive to all images on pages
    $("img").addClass("img-responsive");
    
    // Gallery
    if($('.gallery a').length >0 ){ 
        $('.gallery a').nivoLightbox();
    }

    if($('.sortable-table').length >0 ){ 
        $('.sortable-table').DataTable({
            "searching": false,
            paging: false,
            "info": false
        });
    }

    if($('.wtc-map img').length >0 ){ 
        $('.wtc-map img').mapster({
            fillColor: 'ff0000',
            fillOpacity: 0.3,
            isSelectable: false,
            clickNavigate: true,
            showToolTip: true,
            mapKey: 'alt',
            areas: [
                {key: "A",toolTip: "Konzum"},
                { key: "B", toolTip: "Intersport"},

                { key: "C", toolTip: "Elipso"},
                { key: "D", toolTip: "INTELLIGENT STORE"},
                { key: "E", toolTip: "PitaRosso"},
                { key: "F", toolTip: "Sport Vision"},
                { key: "G", toolTip: "Happy Land"},
                { key: "H", toolTip: "Blitz Cinestar"},
                { key: "I", toolTip: "Zatvoreno"},

                { key: "101",
                    toolTip: "BUZZ"
                },
                { key: "102",
                    toolTip: "itStyle KOZMETIKA"
                },
                { key: "103",
                    toolTip: "Little King"
                },
                { key: "104",
                    toolTip: "TELE2"
                },
                { key: "105",
                    toolTip: "Dicta Tower"
                },
                { key: "106",
                    toolTip: "T-MOBILE"
                },
                { key: "107",
                    toolTip: "Farmacia"
                },
                { key: "108",
                    toolTip: "Exclusive Change"
                },
                { key: "201", toolTip: "Terranova" },
                { key: "203b", toolTip: "BATA" },
                { key: "trgovina/203", toolTip: "Pimkie" },
                { key: "204", toolTip: "SPORTINA" },
                { key: "208", toolTip: "LEE COOPER" },
                { key: "209", toolTip: "Diadema" },
                { key: "210", toolTip: "Replay" },
                { key: "211", toolTip: "Kopitarna" },
                { key: "212", toolTip: "Women’s Secret" },
                { key: "213", toolTip: "Zatvoreno" },
                { key: "214", toolTip: "Ulla Popken" },
                { key: "215", toolTip: "Tezenis" },
                { key: "216", toolTip: "Denis" },
                { key: "217", toolTip: "SPRINGFIELD" },
                { key: "218", toolTip: "Gelateria Corso" },
                { key: "219", toolTip: "Flair" },
                { key: "220", toolTip: "Guess accessories store" },
                { key: "221", toolTip: "Beba Exclusive" },
                { key: "222", toolTip: "Zatvoreno" },
                { key: "223b", toolTip: "Guliver" },
                { key: "225", toolTip: "Nine West" },
                { key: "226", toolTip: "Sally Atelier" },
                { key: "227", toolTip: "Accessoires" },
                { key: "228", toolTip: "FASHION&FRIENDS" },
                { key: "230", toolTip: "Tom Tailor Denim" },
                { key: "231", toolTip: "Galeb" },
                { key: "232", toolTip: "Alpina" },
                { key: "233", toolTip: "Tom Tailor Man" },
                { key: "234", toolTip: "Tom Tailor Woman" },
                { key: "235", toolTip: "Opening Soon!" },
                { key: "237", toolTip: "Orsay" },
                { key: "239", toolTip: "COMMA" },
                { key: "240", toolTip: "Tally Weijl" },
                { key: "242", toolTip: "Mango" },
                { key: "245", toolTip: "Furla Corner" },
                { key: "246", toolTip: "Ciciban" },
                { key: "250", toolTip: "Esprit" },
                { key: "251", toolTip: "GERRY WEBER OPENING SOON" },
                { key: "301b", toolTip: "Zatvoreno" },
                { key: "302", toolTip: "Mass" },
                { key: "304", toolTip: "S. Oliver" },
                { key: "306", toolTip: "The Core" },
                { key: "310", toolTip: "Cubus" },
                { key: "311", toolTip: "Ecco" },
                { key: "312", toolTip: "FRACOMINA" },
                { key: "314", toolTip: "KIBUBA" },
                { key: "315", toolTip: "REGATTA" },
                { key: "316", toolTip: "Skechers Concept Store" },
                { key: "317", toolTip: "Shoe Be Do" },
                { key: "318", toolTip: "L’OCCITANE" },
                { key: "319", toolTip: "Planet Obuća" },
                { key: "319a", toolTip: "Baby Center" },
                { key: "320", toolTip: "VIP" },
                { key: "321", toolTip: "Intimissimi" },
                { key: "322", toolTip: "Calzedonia" },
                { key: "322a", toolTip: "Kerver" },
                { key: "323", toolTip: "Festina" },
                { key: "324", toolTip: "Palmers" },
                { key: "325", toolTip: "Tomas Sport" },
                { key: "328", toolTip: "Galileo" },
                { key: "329", toolTip: "Europa 92" },
                { key: "331", toolTip: "Carpisa" },
                { key: "332", toolTip: "Nike Only Shop" },
                { key: "333", toolTip: "NEXT" },
                { key: "334", toolTip: "Opening Soon!" },
                { key: "335a", toolTip: "Zatvoreno" },
                { key: "335b", toolTip: "Zatvoreno" },
                { key: "336", toolTip: "Luxury Sport Store" },
                { key: "337", toolTip: "Denis" },
                { key: "338", toolTip: "MONDO UOMO" },
                { key: "339", toolTip: "Shoe Box" },
                { key: "340", toolTip: "POLLEO SPORT" },
                { key: "342", toolTip: "Ferivi Sport" },
                { key: "344", toolTip: "Douglas" },
                { key: "347", toolTip: "Dicta Exclusive" },
                { key: "348", toolTip: "Adidas" },
                { key: "351", toolTip: "NAPAPIJRI" },
                { key: "352", toolTip: "5 Star store" },
                { key: "346", toolTip: "Caffe bar Bicicletta" },
                { key: "346a", toolTip: "Amadeus" },
                { key: "346b", toolTip: "Lisca" },
                { key: "354", toolTip: "Argentum" },
                { key: "401", toolTip: "Vet Pet" },
                { key: "402", toolTip: "Studio Superior" },
                { key: "403", toolTip: "Mativo" },
                { key: "404", toolTip: "Zatvoreno" },
                { key: "407", toolTip: "Simple" },
                { key: "408", toolTip: "Kamena Duga" },
                { key: "409", toolTip: "Zatvoreno" },
                { key: "410", toolTip: "Sophoslab" },
                { key: "411", toolTip: "Salmoiraghi & Vigano" },
                { key: "412", toolTip: "KIK" },
                { key: "414", toolTip: "Zlatarna Celje" },
                { key: "415a", toolTip: "Luce" },
                { key: "416", toolTip: "Elegance" },
                { key: "417", toolTip: "Posteljina.hr" },
                { key: "418", toolTip: "Magic Baby" },
                { key: "419", toolTip: "Funky gifts & more" },
                { key: "420", toolTip: "TRIUMPH" },
                { key: "422", toolTip: "iNovine" },
                { key: "423", toolTip: "CCC" },
                { key: "424", toolTip: "Ghetaldus" },
                { key: "425", toolTip: "HOĆU KNJIGU" },
                { key: "426", toolTip: "DM" },
                { key: "430", toolTip: "Proteini.si" },
                { key: "431", toolTip: "Opening Soon!" },
                { key: "432", toolTip: "Dogma" },
                { key: "433", toolTip: "Dević Underwear" },
                { key: "434", toolTip: "Mana Moda" },
                { key: "501", toolTip: "Wettpunkt" },
                { key: "503", toolTip: "Zatvoreno" },
                { key: "504", toolTip: "Sasso Bar" },
                { key: "505", toolTip: "Picadilly" },
                { key: "506", toolTip: "Food City" },
                { key: "509b", toolTip: "Zatvoreno" },
                { key: "509a", toolTip: "Zabavni klub Tower Centar" },
                { key: "510a", toolTip: "Zatvoreno" },
                { key: "514", toolTip: "Tobacco Shop" },
                { key: "515", toolTip: "Zatvoreno" },
                { key: "516", toolTip: "Zatvoreno" }
                ]
        });
    }
    
});

// filtrzr -> template news.html
if(jQuery('.news-container').length >0 ){ 
    jQuery(document).ready(function(){
        jQuery('.news-container').filterizr();
    });
    
    jQuery(document).on('click','.simplefilter li',function(){
        jQuery('.simplefilter li').removeClass('active');
        jQuery(this).addClass('active');
    });
}
